// extracted by mini-css-extract-plugin
module.exports = {"method":"styles_method__2d39r","info":"styles_info__3Awfg","questions":"styles_questions__2rRNE"};